import NotificationMenu from './NotificationMenuContainer';

export default NotificationMenu;
